
function checkIsHoppyTrigger(link) {
  if (typeof window.isHoppyTrigger === 'function') return window.isHoppyTrigger(link);
  if (!link) return false;
  var s = link.trim().toLowerCase();
  if (s === 'hoppy' || s === '#hoppy') return true;
  if (s.startsWith('hoppy-') || s.startsWith('#hoppy-') || s.startsWith('hoppy_') || s.startsWith('#hoppy_') || s.startsWith('hoppy:') || s.startsWith('#hoppy:')) return true;
  if (s.startsWith('futureblink-') || s.startsWith('#futureblink-') || s.startsWith('futureblink_') || s.startsWith('#futureblink_')) return true;
  if (/^#?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(link.trim())) return true;
  return false;
}

function getHoppyIdFromLink(link) {
  if (typeof window.extractHoppyId === 'function') return window.extractHoppyId(link);
  if (!link) return '';
  var s = link.trim();
  if (s.toLowerCase() === 'hoppy' || s.toLowerCase() === '#hoppy') return '';
  return s.replace(/^#?(hoppy|futureblink)[-_:]?/i, '').replace(/^#/, '').trim();
}

/** InsCoder WANG.J 2026-07-15 B + Register product banner pop-up block **/
if (!customElements.get("cust-banner-pop-up")) {
  customElements.define(
    "cust-banner-pop-up",
    class CustBannerPopUp extends HTMLElement {
      connectedCallback() {
        this.handleClickBound = this.handleClick.bind(this);
        this.addEventListener("click", this.handleClickBound);

        this.handleVariantChangeBound = this.handleVariantChange.bind(this);
        document.addEventListener("variant:changed", this.handleVariantChangeBound);

        if (window.FoxTheme?.pubsub?.subscribe && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.variantChange) {
          this.variantChangeUnsubscriber = window.FoxTheme.pubsub.subscribe(
            window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            (event) => this.handleVariantChange(event)
          );
        }

        // Synchronize initial variant status on mount/remount
        this.syncCurrentVariantState();
      }

      disconnectedCallback() {
        if (this.handleClickBound) {
          this.removeEventListener("click", this.handleClickBound);
        }
        if (this.handleVariantChangeBound) {
          document.removeEventListener("variant:changed", this.handleVariantChangeBound);
        }
        if (typeof this.variantChangeUnsubscriber === "function") {
          this.variantChangeUnsubscriber();
        }
      }

      syncCurrentVariantState() {
        var productInfo = this.closest("product-info") || document.querySelector("product-info");
        var variant = productInfo?.currentVariant;

        if (!variant) {
          try {
            var variantEl =
              document.querySelector("variant-selects [data-selected-variant]") ||
              document.querySelector("[data-product-selected-variant]");
            if (variantEl?.textContent) {
              variant = JSON.parse(variantEl.textContent);
            }
          } catch (e) {}
        }

        if (!variant) {
          var inputVal = document.querySelector('product-form input[name="id"]')?.value;
          if (inputVal) {
            variant = { id: inputVal };
          }
        }

        var isSoldOut = false;
        if (variant && typeof variant.available === "boolean") {
          isSoldOut = variant.available === false;
        } else if (!variant || variant.available === false) {
          isSoldOut = true;
        } else {
          var mainSubmitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
          if (mainSubmitBtn) {
            isSoldOut =
              mainSubmitBtn.hasAttribute("disabled") ||
              mainSubmitBtn.getAttribute("data-waitlist-trigger") === "true";
          }
        }

        this.updateItemState(isSoldOut, variant);
      }

      handleVariantChange(event) {
        var variant = event?.detail?.variant ?? event?.data?.variant ?? event?.variant;

        var isSoldOut = false;
        if (variant && typeof variant.available === "boolean") {
          isSoldOut = variant.available === false;
        } else if (event?.data?.html) {
          var addBtn =
            event.data.html.querySelector?.('[name="add"]') ||
            event.data.html.getElementById?.("ProductSubmitButton-" + event?.data?.sectionId);
          if (
            addBtn &&
            (addBtn.hasAttribute("disabled") ||
              addBtn.getAttribute("data-waitlist-trigger") === "true")
          ) {
            isSoldOut = true;
          }
        } else {
          var mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');
          if (mainBtn) {
            isSoldOut =
              mainBtn.hasAttribute("disabled") ||
              mainBtn.getAttribute("data-waitlist-trigger") === "true";
          }
        }

        this.updateItemState(isSoldOut, variant);
      }

      updateItemState(isSoldOut, variant) {
        var item2 = this.querySelector('.cust-banner-pop-up__item[data-item-index="2"]');

        if (item2) {
          var linkB =
            item2.getAttribute("data-link-b") ??
            item2.getAttribute("data-popup-link") ??
            "";
          var linkA = item2.getAttribute("data-link-a") ?? linkB;
          var nextLink = isSoldOut ? (linkA || linkB) : linkB;

          item2.setAttribute("data-popup-link", nextLink);

          if (item2.tagName === "A") {
            item2.setAttribute("href", nextLink || "#");
          }

          if (nextLink) {
            item2.classList.add("cust-banner-pop-up__item--link");
            item2.removeAttribute("aria-haspopup");
          } else {
            item2.classList.remove("cust-banner-pop-up__item--link");
            item2.setAttribute("aria-haspopup", "dialog");
          }
        }

        if (variant) {
          this.querySelectorAll(".cust-banner-pop-up__item").forEach(function (item) {
            if (variant.id) {
              item.setAttribute("data-variant-id", String(variant.id));
            }
            if (variant.title) {
              item.setAttribute("data-variant-title", variant.title);
            }
          });
        }
      }

      handleClick(event) {
        var item = event.target.closest(".cust-banner-pop-up__item");
        if (!item) return;

        var rawLink = item.hasAttribute("data-popup-link")
          ? (item.getAttribute("data-popup-link") || "")
          : (item.getAttribute("href") || "");
        var link = rawLink.trim();

        if (link === "#" || link.toLowerCase().startsWith("javascript:")) {
          link = "";
        }

        var modalId =
          item.getAttribute("aria-controls") ||
          item.getAttribute("data-modal-id");

        var isHoppy = checkIsHoppyTrigger(link);
        var isEcomsend = link.toLowerCase().includes("ecomsend");
        var isHash = link.startsWith("#");

        // 1. Hoppy Back-in-stock / Email popup trigger
        if (isHoppy) {
          event.preventDefault();
          event.stopPropagation();
          var targetId = getHoppyIdFromLink(link);

          var productId = item.getAttribute("data-product-id") || "";

          if (typeof window.triggerHoppyPopup === "function") {
            if (window.triggerHoppyPopup(targetId, productId)) return;
            var attempts = 0;
            var timer = setInterval(function () {
              attempts++;
              if (window.triggerHoppyPopup(targetId, productId) || attempts >= 20) {
                clearInterval(timer);
              }
            }, 100);
            return;
          }

          var popups = window.emailCollectionBarData?.emailPopups || [];
          var hoppyData = targetId
            ? popups.find(function (p) { return p.id === targetId || p._id === targetId; })
            : null;
          var activeId = targetId || hoppyData?.id || hoppyData?._id;

          var popup = activeId ? document.getElementById("futureblink-email-popup-" + activeId) : null;
          var overlay = activeId ? document.getElementById("futureblink-email-popup-overlay-" + activeId) : null;

          if ((!popup || !overlay) && hoppyData && typeof window.normalPopup === "function") {
            try {
              var bypassData = JSON.parse(JSON.stringify(hoppyData));
              if (bypassData.placement) {
                bypassData.placement.pages_type = "all";
                bypassData.placement.pages = [];
                bypassData.placement.exclude_pages_type = "none";
                bypassData.placement.exclude_pages = [];
                bypassData.placement.allowed_all_location = true;
                bypassData.placement.locations = [];
              }
              if (bypassData.trigger) {
                bypassData.trigger.type = "time_delay";
                bypassData.trigger.show_popup = 0;
                bypassData.trigger.display_freq = "everytime";
                bypassData.trigger.freq_limit = "999";
              }
              window.normalPopup(bypassData);
              popup = activeId ? document.getElementById("futureblink-email-popup-" + activeId) : null;
              overlay = activeId ? document.getElementById("futureblink-email-popup-overlay-" + activeId) : null;
              if (!popup) {
                window.normalPopup(hoppyData);
                popup = activeId ? document.getElementById("futureblink-email-popup-" + activeId) : null;
                overlay = activeId ? document.getElementById("futureblink-email-popup-overlay-" + activeId) : null;
              }
            } catch (e) {}
          }

          if (popup) {
            popup.style.setProperty("display", "block", "important");
            if (overlay) overlay.style.setProperty("display", "block", "important");
          }
          return;
        }

        // 2. EcomSend / CwillSendwill popup trigger
        if (isEcomsend) {
          var ecomsendId = link.replace(/.*Ecomsend_popups_open_/i, "").replace(/^#/, "").trim();

          try {
            if (window.location.hash !== link) {
              window.location.hash = link;
            }
            window.dispatchEvent(new HashChangeEvent("hashchange"));
          } catch (e) {}

          if (typeof window.CwillSendwill?.openPopup === "function") {
            try { window.CwillSendwill.openPopup(ecomsendId); } catch (e) {}
          }
          if (typeof window.Sendwill?.open === "function") {
            try { window.Sendwill.open(ecomsendId); } catch (e) {}
          }
          if (typeof window.EcomSend?.open === "function") {
            try { window.EcomSend.open(ecomsendId); } catch (e) {}
          }
          if (typeof window.Ecomsend?.openPopup === "function") {
            try { window.Ecomsend.openPopup(ecomsendId); } catch (e) {}
          }

          // If item is an A tag, let the click bubble naturally to document without stopPropagation so EcomSend can handle it
          if (item.tagName === "A") {
            return;
          }

          event.preventDefault();
          var anchor = document.createElement("a");
          anchor.href = link;
          anchor.style.position = "fixed";
          anchor.style.top = "-9999px";
          anchor.style.left = "-9999px";
          anchor.style.opacity = "0";
          document.body.appendChild(anchor);
          anchor.click();
          setTimeout(function () { anchor.remove(); }, 1000);
          return;
        }

        // 3. Other generic hash anchors
        if (isHash) {
          event.preventDefault();
          event.stopPropagation();
          var targetEl = document.querySelector(link);
          if (targetEl && targetEl !== item) {
            if (typeof targetEl.showModal === "function") {
              targetEl.showModal();
              return;
            }
            if (typeof targetEl.open === "function") {
              targetEl.open();
              return;
            }
            if (typeof targetEl.show === "function") {
              targetEl.show();
              return;
            }
          }

          try {
            if (window.location.hash !== link) {
              window.location.hash = link;
            }
            window.dispatchEvent(new HashChangeEvent("hashchange"));
          } catch (e) {}
          return;
        }

        // 4. Built-in drawer modal (when link is blank)
        if (!link && modalId) {
          event.preventDefault();
          event.stopPropagation();
          var modal = document.getElementById(modalId);
          if (modal) {
            if (typeof modal.show === "function") {
              modal.show(item);
            } else if (typeof modal.open === "function") {
              modal.open();
            } else {
              modal.setAttribute("open", "");
            }
          }
          return;
        }

        // 5. Normal URL navigation on button
        if (link && item.tagName === "BUTTON") {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = link;
        }
      }
    }
  );
}
/** InsCoder WANG.J 2026-07-15 E + Register product banner pop-up block **/
